import initialState from "./initial"

function softphoneReducer(state = initialState.softphone, action) {
    if (action.type === "SET_API_KEY") {
        state = state.set("apiKey", action.payload)
    }
    if (action.type === "SOFTPHONE_REGISTERED") {
        state = state.set("registered", action.payload)
    }
    if (action.type === "SOFTPHONE_ERROR") {
        state = state.set("error", action.error)
    }
    if (action.type === "SHOW_SOFTPHONE") {
        state = state.set("show", action.show)
    }
    if (action.type === "HIDE_SOFTPHONE") {
        state = state.set("show", action.show)
    }
    if (action.type === "SOFTPHONE_CALL_START") {
        state = state.set("status", "calling").set("number", action.number)
    }
    if (action.type === "SOFTPHONE_CALL_FINISH") {
        state = state.set("status", "idle").set("number", "")
    }
    if (action.type === "SOFTPHONE_ICE_SERVERS") {
        state = state.set("iceServers", action.data)
    }
    if (action.type === "SOFTPHONE_SIP_SERVERS") {
        state = state.set("sipServers", action.data)
    }
    if (action.type === "SOFTPHONE_SIP_CREDENTIALS") {
        state = state.set("sipCredentials", action.data)
    }
    if (action.type === "SOFTPHONE_AUTH") {
        state = state.set("auth", action.payload)
    }
    if (action.type === "SET_DIAL_IN") {
        state = state.set("dial", action.payload)
    }
    if (action.type === "SET_HANGUP") {
        state = state.set("hangup", action.payload)
    }
    if (action.type === "SET_DESTROY") {
        state = initialState.softphone.set("destroy", action.payload).set("postbackURL", state.get("postbackURL"))
    }
    if (action.type === "SET_POSTBACK_URL") {
        state = state.set("postbackURL", action.payload)
    }
    if (action.type === "SET_DIAL_OPTIONS") {
        state = state.set("dialOptions", action.payload)
    }
    if (action.type === "SET_POSTRESET_DIAL_OPTIONSBACK_URL") {
        state = state.set("dialOptions", action.payload)
    }

    return state
}

const agentReducer = (state = initialState.agent, action) => {
    if (action.type === "AGENT_CAMPAIGN_INT") {
        return state.set("campaign", action.data)
    }
    if (action.type === "AGENT_CONTACT") {
        return state.set("contact", action.data && action.data.get("id") ? action.data : null)
    }
    if (action.type === "AGENT_CONTACT_ANY") {
        return state.set("contact", action.data && action.data.get("phonenumber") ? action.data : null)
    }
    if (action.type === "AGENT_PRESENCE") {
        return state.set("presence", action.data).set("presencechanged", action.changed)
    }
    if (action.type === "SOCKETS_CONNECTED") {
        return state.set("connected", true)
    }
    if (action.type === "SOCKETS_DISCONNECTED") {
        return state.set("connected", false)
    }
    if (action.type === "AGENT_INTERCEPTED") {
        return state.set("intercepted", action.data)
    }
    if (action.type === "AGENT_INTERCEPTING") {
        return state.set("intercepting", action.data)
    }
    return state
}

const callReducer = (state = initialState.call, action) => {
    if (action.type === "CALL_STARTED") {
        return action.data
    }
    if (action.type === "CALL_FINISHED") {
        return {}
    }
    return state
}

const checksReducer = (state = initialState.checks, action) => {
    if (action.type === "CHECKS_LATENCY") {
        return { ...state, latency: [...state.latency, action.data].slice(-100) }
    }
    if (action.type === "START_TEST") {
        return { ...state, startTest: action.data }
    }
    if (action.type === "START_AUDIO_TEST") {
        return { ...state, startAudioTest: action.data }
    }

    return state
}

const callIntelligenceReducer = (state = initialState.callIntelligence, action) => {
    switch (action.type) {
        case "CALL_INTELLIGENCE_RESET":
            return initialState.callIntelligence

        case "CALL_INTELLIGENCE_SET_ENV":
            return { ...state, ...(action?.data || {}) }

        case "CALL_INTELLIGENCE_SET_TRINSCRIBER":
            return { ...state, transcriber: action?.data || null }

        case "CALL_INTELLIGENCE_SET_MESSAGE":
            const msg = action.data
            let newDiff = null
            const newMessages = [...state.messages].filter(t => t.id !== msg.id)
            newMessages.push(msg)
            newMessages.sort((a, b) => a.ts - b.ts)
            if (["agent", "customer"].includes(msg.role)) {
                newDiff = [...state.diff.filter(t => t.id !== msg.id), msg]
            }
            return { ...state, ...(newDiff ? { diff: newDiff } : {}), messages: newMessages }

        case "CALL_INTELLIGENCE_CLEAR_DIFF":
            return { ...state, diff: [] }

        case "CALL_INTELLIGENCE_CLEAR":
            return { ...state, diff: [], messages: [] }

        default:
            return state
    }
}

const optionsReducer = (state = initialState.options, action) => {
    switch (action.type) {
        case "SET_OPTIONS":
            return { ...state, ...(action?.data || {}) }

        default:
            return state
    }
}

function dialParamsReducer(state = initialState.dialParams, action) {
    switch (action.type) {
        case "SET_DIAL_PARAMS":
            return { ...state, ...(action?.data || {}) }

        default:
            return state
    }
}

const reducers = {
    agent: agentReducer,
    softphone: softphoneReducer,
    call: callReducer,
    checks: checksReducer,
    callIntelligence: callIntelligenceReducer,
    options: optionsReducer,
    dialParams: dialParamsReducer,
}

export default reducers
